/**
 * Checks if the event target is an editable element (input, textarea, select, contenteditable)
 */
export function isEventTargetEditable(event: KeyboardEvent): boolean {
  const target = event.target as HTMLElement;

  if (!target) {
    return false;
  }

  // Check if it's an input, textarea, or select element
  const tagName = target.tagName.toLowerCase();
  if (tagName === 'input' || tagName === 'textarea' || tagName === 'select') {
    return true;
  }

  // Check if element has contenteditable attribute
  if (target.isContentEditable) {
    return true;
  }

  return false;
}
